import {
  IFunctionElementUnion,
  IRepeatableElement,
} from "@graffer-inc/form-schema";
import {
  ApplicantSchemaKeys,
  isReplacedApplicantCorporateSearchComponent,
} from "@graffer-inc/cloud-gov-core";
import {
  IFunctionFieldTemplateRegistry,
  DefaultFunctionFieldTemplateRegistry,
} from "@graffer-inc/form-generator";

// 従来の挙動へ合わせて、申請者情報内の法人検索コンポーネントを
// 非表示とするための FunctionFieldTemplateRegistry
export class PreviewFunctionFieldTemplateRegistry
  implements IFunctionFieldTemplateRegistry
{
  constructor(private readonly applicantSchemaKeys: ApplicantSchemaKeys) {}

  get(element: IFunctionElementUnion, repeatable?: IRepeatableElement) {
    if (
      isReplacedApplicantCorporateSearchComponent(
        element,
        this.applicantSchemaKeys,
      )
    ) {
      return () => null;
    }
    return DefaultFunctionFieldTemplateRegistry.get(element, repeatable);
  }
}
